import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const Menu = styled.button<{ isActive: boolean }>`
  ${({ theme, isActive }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: ${isActive
      ? theme.content.hierarchy1
      : theme.content.content_light_5};
    text-align: center;
    cursor: pointer;
  `}
`;

export const Title = styled.strong<{ active: boolean }>`
  ${({ theme, active }) => css`
    display: block;
    color: ${active ? theme.content.hierarchy1 : theme.content.content_light_5};
    ${theme.fontStyle.label.list12_medium}
  `}
`;
